import "./index.css";
import { useEffect, useState } from "react";


export default function LoadingState() {
const words = ["harder", "better", "faster", "stronger"];
const [current, setCurrent] = useState(0);


useEffect(() => {
const interval = setInterval(() => {
setCurrent((prev) => (prev + 1) % words.length);
}, 1200);
return () => clearInterval(interval);
}, []);


return (
<div className="empty-message-holder flex flex-col items-center justify-center p-4">
<div className="thinking-wrapper text-gray-500 text-lg font-medium">
Thinking 
<span key={current} className="rotating-word ml-2 inline-block">
{words[current]}
</span>
</div>
</div>
);
}